import http from 'plugins/axios';

export default {
  getRecords(data) {
    return http.get({
      url: '/la/admin/newperson/getList',
      data
    });
  }
  //   setNode(data) {
  //     return http.post({
  //       url: '/la/admin/starplan/create/node',
  //       data,
  //       dataType: 'form'
  //     });
  //   }
};
